module.exports = __webpack_public_path__ + "img/boekenplank.6b265a57.png";